import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';

import PageHeader from '../../components/page-header/page-header.component';
import './not-found.styles.scss';

// Depuis l'ajout du fallback SPA (public/.htaccess), Apache renvoie index.html pour
// toute URL inconnue : c'est donc à React d'afficher le « page introuvable ».
// Deux points d'entrée : la route catch-all de router.js, et category.component.jsx
// quand /shop/<catégorie> ne correspond à rien du catalogue.
const NotFound = () => {
  return (
    <div className="not-found">
      <PageHeader
        overline="Erreur 404"
        title="Page introuvable"
        lead="La page que vous cherchez n'existe pas ou a été déplacée."
      />

      <Link className="brand-link" to="/">
        Retour à l'accueil
        <span className="brand-link-arrow" aria-hidden="true">
          <BsArrowRight />
        </span>
      </Link>
    </div>
  );
};

export default NotFound;
